var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/ui/form-group/form-group.tsx";
import React, { useMemo } from 'react';
import { v4 as uuidv4 } from 'uuid';
import Checkbox from '../checkbox/checkbox';
import HStack from '../hstack/hstack';
import Stack from '../stack/stack';

/** Input container with label. Renders the child. */
const FormGroup = props => {
  var _firstChild;

  const {
    children,
    errors = [],
    labelText,
    labelTitle,
    hintText
  } = props;
  const formFieldId = useMemo(() => "field-".concat(uuidv4()), []);
  const inputChildren = React.Children.toArray(children);
  const hasError = (errors === null || errors === void 0 ? void 0 : errors.length) > 0;
  let firstChild;

  if ( /*#__PURE__*/React.isValidElement(inputChildren[0])) {
    firstChild = /*#__PURE__*/React.cloneElement(inputChildren[0], {
      id: formFieldId,
      hasError
    });
  }

  const isCheckboxFormGroup = ((_firstChild = firstChild) === null || _firstChild === void 0 ? void 0 : _firstChild.type) === Checkbox;

  if (isCheckboxFormGroup) {
    return /*#__PURE__*/React.createElement(HStack, {
      alignItems: "start",
      space: 2,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 37,
        columnNumber: 7
      }
    }, firstChild, /*#__PURE__*/React.createElement(Stack, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 40,
        columnNumber: 9
      }
    }, labelText && /*#__PURE__*/React.createElement("label", {
      htmlFor: formFieldId,
      "data-testid": "form-group-label",
      className: "-mt-0.5 block text-sm font-medium text-gray-900 dark:text-gray-100",
      title: labelTitle,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 42,
        columnNumber: 13
      }
    }, labelText), hasError && /*#__PURE__*/React.createElement("div", {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 53,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement("p", {
      "data-testid": "form-group-error",
      className: "mt-0.5 text-xs text-danger-900 bg-danger-200 rounded-md inline-block px-2 py-1 relative form-error",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 54,
        columnNumber: 15
      }
    }, errors.join(', '))), hintText && /*#__PURE__*/React.createElement("p", {
      "data-testid": "form-group-hint",
      className: "mt-0.5 text-xs text-gray-700 dark:text-gray-600",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 64,
        columnNumber: 13
      }
    }, hintText)));
  }

  return /*#__PURE__*/React.createElement("div", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 74,
      columnNumber: 5
    }
  }, labelText && /*#__PURE__*/React.createElement("label", {
    htmlFor: formFieldId,
    "data-testid": "form-group-label",
    className: "block text-sm font-medium text-gray-900 dark:text-gray-100",
    title: labelTitle,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 76,
      columnNumber: 9
    }
  }, labelText), /*#__PURE__*/React.createElement("div", {
    className: "mt-1 dark:text-white",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 86,
      columnNumber: 7
    }
  }, firstChild, inputChildren.filter((_, i) => i !== 0), hasError && /*#__PURE__*/React.createElement("p", {
    "data-testid": "form-group-error",
    className: "mt-0.5 text-xs text-danger-900 bg-danger-200 rounded-md inline-block px-2 py-1 relative form-error",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 91,
      columnNumber: 11
    }
  }, errors.join(', ')), hintText && /*#__PURE__*/React.createElement("p", {
    "data-testid": "form-group-hint",
    className: "mt-0.5 text-xs text-gray-700 dark:text-gray-600",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 100,
      columnNumber: 11
    }
  }, hintText)));
};

export default FormGroup;